import { LoaderFunctionArgs } from 'react-router-dom';

import { assertPresence } from '../../lib/runtime';
import { parseSearchParams } from '../../lib/url';
import {
	loadAdminRewards,
	loadCatalogMetadata,
	loadCatalogSettings,
	loadCollection,
	loadCollectionItems,
	loadCollections,
	loadSwagIntegration,
} from '../../queries/rewards';
import { getManageItemsParamsFromUrl } from './manage-items/hooks';
import { createCollectionParamParser } from './utils';

export const loadSettings = () => loadCatalogSettings();
export const loadIndex = () => Promise.all([loadCollections(), loadCatalogSettings(), loadCatalogMetadata(), loadSwagIntegration()]);

export const loadCollectionDetail = async ({ params, request }: LoaderFunctionArgs) => {
	const { id } = params;
	const searchParams = new URL(request.url).searchParams;
	const queryParams = parseSearchParams(searchParams, ...createCollectionParamParser());
	assertPresence(id);
	const [collection] = await Promise.all([loadCollection(id), loadCatalogSettings()]);

	return loadCollectionItems(collection.id, queryParams);
};

export const loadItems = async ({ request }: LoaderFunctionArgs) => {
	const url = new URL(request.url);
	const params = getManageItemsParamsFromUrl(url.search);

	// Preload metadata before fetching admin rewards
	await loadCatalogMetadata();

	return loadAdminRewards(params);
};

export const loadExclusiveItems = () =>
	loadAdminRewards({
		collection: 'exclusive',
		pageNumber: 1,
	});

export const loadSwagItems = () =>
	Promise.all([
		loadAdminRewards({
			collection: 'swag',
			pageNumber: 1,
		}),
		loadSwagIntegration(),
	]);
